<template>

    <!-- Info text -->
    <div class="page-heading__text mb-14">
        <div class="mb-1">
            Stranki lahko pošljete povezavo za izračun limita za nakup na obroke.
        </div>
        <div>
            Na povezavi bo stranka lahko izračunala svoj limit ali oddala vlogo za odobritev limita vnaprej.
        </div>
    </div>

    <LimitCalculationSendComponent
        ref="sendComponent"
        v-model:data="LimitCalculationSendDataObject"
        @send="handleSendCalculation">
    </LimitCalculationSendComponent>

</template>

<script setup lang="ts">
import { ref } from "vue";
import { ILimitCalculationSendComponentObject, LimitCalculationSendComponent } from "nlb-buy-go-library";
import { useLimitCalculationSendDataObject } from "@/app/store/app/limit-calculation-component/limit-calculation-send-component";

const { LimitCalculationSendDataObject } = useLimitCalculationSendDataObject();

const sendComponent = ref();

//tuki oz potem v lib pride še dejansko pošiljanje more SIMON implementirat
const handleSendCalculation = async (data: ILimitCalculationSendComponentObject) => {
    try {

        console.log("Sending calculation with:", data);
    } catch (error) {
        console.error("Error sending calculation:", error);
    }
};

async function navigationAction(buttonId: string) {
    const result = await sendComponent.value?.navigationAction?.(buttonId);
    return result;
}

defineExpose({ navigationAction });
</script>